import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Reward } from '../types';
import { RewardIcon } from './RewardIcon';

interface TimelineItemProps {
  reward: Reward;
  currentFoc: number;
}

export const TimelineItem: React.FC<TimelineItemProps> = ({ reward, currentFoc }) => {
  const isStrictlyCurrent = reward.order === currentFoc;
  const isStrictlyPast = reward.order < currentFoc;
  const state = isStrictlyCurrent ? 'current' : 'default';

  return (
    <div className="subscription-timeline__timeline-item">
      <div
        className={`subscription-timeline__icon-wrapper subscription-timeline__icon-wrapper--${state}`}>
        <RewardIcon isCurrent={isStrictlyCurrent} isPast={isStrictlyPast} />
      </div>

      <div
        className={`subscription-timeline__order-number subscription-timeline__order-number--${state}`}>
        <FormattedMessage id="TIMELINE.DELIVERY_NUMBER" values={{ order: reward.order }} />
      </div>

      <div
        className={`subscription-timeline__reward-label subscription-timeline__reward-label--${state}`}>
        {/* `reward.label` is a message id — see rewardsConfig.ts */}
        <FormattedMessage id={reward.label} />
      </div>
      {/* 
      {isStrictlyCurrent && (
        <div className="subscription-timeline__current-indicator">
          <span>Du bist hier</span>
        </div>
      )} */}
    </div>
  );
};
